/**
 * Copyright 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const MODULE_NOT_FOUND_REACT_NATIVE_ASYNC_STORAGE = 'Module not found: @react-native-async-storage/async-storage';
export const getDefaultAsyncStorage = () => {
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return require('@react-native-async-storage/async-storage').default;
    }
    catch (e) {
        throw new Error(MODULE_NOT_FOUND_REACT_NATIVE_ASYNC_STORAGE);
    }
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=async-storage.js.map